import 'css-chunksrc/client/scenes/workloads/graph/elementsOverlay/element/progress/styles.scss';export default {
  "progress": "_progress_oaroo_1",
  "bar": "_bar_oaroo_7"
};